import React, { useEffect, useState } from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import { BsChatSquareDots } from 'react-icons/bs'
import * as normalActions from '../store/actions'
import { hasStory } from '../utils/story'
import '../styles/profileInfoPart.css'
import UserAvatar from './userAvatar'
import { fetchUserCommunities } from '../data/communities_data'

const ProfileInfoPart = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [communities, setCommunities] = useState([])
  const [zombie, setZombie] = useState(null)
  const user = useSelector(state => state.followReduse.follow.find(item => item.userid === props.userlist.id)) || {}
  const myFollowing = useSelector(state => state.followReduse.follow)
  const followingCount = props.vist
    ? Number(props.userlist?.follow) || 0
    : (Array.isArray(myFollowing) && myFollowing.length
      ? myFollowing.length
      : Number(props.userlist?.follow) || 0)

  useEffect(() => {
    const id = props.userlist?.id
    if (!id) return undefined
    let alive = true
    fetchUserCommunities(id).then((rows) => { if (alive) setCommunities(rows) }).catch(() => { if (alive) setCommunities([]) })
    return () => { alive = false }
  }, [props.userlist?.id])

  useEffect(() => {
    const id = props.userlist?.id
    if (!id) return undefined
    let alive = true
    fetch(`/api/zombie/stats/${encodeURIComponent(id)}`)
      .then((res) => res.ok ? res.json() : Promise.reject(new Error('stats')))
      .then((data) => { if (alive) setZombie(data.stats || null) })
      .catch(() => { if (alive) setZombie(null) })
    return () => { alive = false }
  }, [props.userlist?.id])

  const handleFollow = () => {
    if (props.userlist?.id) dispatch(normalActions.add_to_follow(props.userlist.id))
  }

  const handleMessage = () => {
    if (props.navigatee) {
      props.navigatee()
    } else if (props.userlist?.id) {
      navigate(`../chat/${props.userlist.id}`)
    }
  }

  const pronoun = props.userlist?.postion || ''
  const subtitle = [props.userlist?.job, props.userlist?.hobby].filter(Boolean).join(' | ')
  const live = hasStory(props.userlist?.story)
  const canAdd = !props.vist

  return (
    <section className='ProfileInfoPart'>
      <div className='ProfileCard'>
        <div className='ProfileHeaderRow'>
          <div className='ProfileAvatarOuter'>
            <div
              className={`ProfileAvatarInner${live ? ' hasStory' : ''}${canAdd ? ' canAddStory' : ''}`}
              onClick={props.story}
              role="button"
              tabIndex={0}
              onKeyDown={event => { if (event.key === 'Enter' || event.key === ' ') props.story?.() }}
            >
              <UserAvatar
                className='ProfileAvatar'
                alt='avatar'
                name={props.userlist?.name || props.userlist?.email}
                src={props.userlist?.photo}
              />
              {canAdd && !live ? <span className="storyAddBadge">+</span> : null}
            </div>
          </div>

          <div className='ProfileHeaderInfo'>
            <div className='ProfileNameBlock'>
              <h1>{props.userlist?.email || 'Username'}</h1>
              {pronoun && <p className='ProfileCountry'>{pronoun}</p>}
            </div>
           
            <div className='ProfileStatsRow'>
              <div className='ProfileStat'>
                <strong>{props.postsCount ?? 0}</strong>
                <span>posts</span>
              </div>
              <div
                className={props.click2 ? 'ProfileStat ProfileStatClick' : 'ProfileStat'}
                onClick={props.click2}
                role={props.click2 ? 'link' : undefined}
              >
                <strong>{props.userlist?.followers ?? 0}</strong>
                <span>followers</span>
              </div>
              <div
                className={props.click1 ? 'ProfileStat ProfileStatClick' : 'ProfileStat'}
                onClick={props.click1}
                role={props.click1 ? 'link' : undefined}
              >
                <strong>{followingCount}</strong>
                <span>following</span>
              </div>
            </div>
          </div>
        </div>

        {props.userlist?.bio && (
          <div className='ProfileBio'>
             {subtitle && <p className='ProfileSubtitle'>{subtitle}</p>}
            <p>{props.userlist.bio}</p>
          </div>
        )}

        {zombie && zombie.games > 0 && (
          <div className="zombieProfileRecords">
            {zombie.wins > 0 && (
              <button type="button" className="zombieProfileBadge" onClick={() => navigate('/zombie')} title="Halloween Zombie winner">
                <span>☠</span>
                <b>Last Survivor ×{zombie.wins}</b>
                <em>{Math.floor(zombie.bestSurvivalMs / 60000)}m {Math.floor((zombie.bestSurvivalMs % 60000) / 1000)}s</em>
              </button>
            )}
            <button type="button" className="zombieProfileBadge isBiter" onClick={() => navigate('/zombie')} title="Zombie bite record">
              <span>🧟</span>
              <b>{zombie.totalBites} bites</b>
              <em>record {zombie.bestBites} in one game</em>
            </button>
            <button type="button" className="zombieProfileBadge isSurvival" onClick={() => navigate('/zombie')} title="Longest time before being bitten">
              <span>⏱</span>
              <b>Longest unbitten</b>
              <em>{Math.floor(zombie.bestSurvivalMs / 60000)}m {Math.floor((zombie.bestSurvivalMs % 60000) / 1000)}s</em>
            </button>
          </div>
        )}

        {communities.length > 0 && (
          <div className="profileHighlights">
            {communities.map((group) => (
              <button
                type="button"
                key={group.id}
                className="profileHighlight"
                onClick={() => navigate(`/community/${group.id}`)}
              >
                <span className="profileHighlightRing">
                  <UserAvatar src={group.img} name={group.name} />
                </span>
                <em>{group.name}</em>
              </button>
            ))}
          </div>
        )}

        {props.vist && (
          <div className='ProfileActionRow'>
            <button className='ProfileButton primary' type='button' onClick={handleFollow}>
              {user.userid !== props.userlist?.id ? 'Follow back' : 'Following'}
            </button>
            <button className='ProfileButton secondary' type='button' onClick={handleMessage}>
              <BsChatSquareDots /> Message
            </button>
            <button className='ProfileButton icon' type='button'>
              +
            </button>
          </div>
        )}
      </div>
    </section>
  )
}

export default ProfileInfoPart
